const MULTIPLE_PRODUCTS_ENDING = [
  '5',
  '6',
  '7',
  '8',
  '9',
  '0',
  '11',
  '12',
  '13',
  '14',
  '15',
  '16',
  '17',
  '18',
  '19',
];
/**
 * Окончание "товаров" в зависимости от размера комплекта
 */
export const productsCountEnding = (count: number | undefined) => {
  if (count?.toString().slice(-1) && MULTIPLE_PRODUCTS_ENDING.includes(count?.toString().slice(-1))) {
    return 'товаров';
  }
  if (count?.toString().slice(-1) === '1') {
    return 'товар';
  }
  return 'товара';
};
